import { Component, OnInit } from '@angular/core'
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { MessageService } from 'primeng/api'
import { AuthService } from '../../../../api/services'
import { validateAllFormFields } from '../../../../formUtils'

@Component({
  selector: 'app-enter-token',
  templateUrl: './enter-token.component.html',
  styleUrls: ['./enter-token.component.css'],
})
export class EnterTokenComponent implements OnInit {
  emergencyToken: UntypedFormGroup
  errorValidationSummary: string = ''
  ShowErrorSummary: boolean = false
  userName: string = ''
  displaypopup: boolean = false

  private key: string
  private isTwoFactorOn: string

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private authService: AuthService,
    private messageService: MessageService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.displaypopup = true

    this.route.queryParams.subscribe((params) => {
      let data = params
      this.userName = data.u_Name
    })
    this.emergencyToken = this.fb.group({
      emergencyToken: ['', Validators.required],
    })
  }
  resetToken(): void {
    validateAllFormFields(this.emergencyToken)
    if (this.emergencyToken.invalid) {
      return
    }
    this.authService
      .authValidateEmergencyToken({
        token: this.emergencyToken.get('emergencyToken').value,
      })
      .subscribe(
        (x) => {
          this.messageService.add({
            key: 'alertToast',
            severity: 'success',
            summary: 'Confirmation',
            detail: 'Security Token validated Successfully',
            life: 7000,
          })
          this.router.navigate(['Forgotpwd-change'], {
            state: { key: '' },
            queryParams: { u_Name: this.userName },
            skipLocationChange: true,
          })
        },
        (err) => {
          console.error(err)
          // this.messageService.add({ severity: 'error', detail: `something went wrong in saving`, summary: 'Error in saving questions' })
          this.messageService.add({
            key: 'alertToast',
            severity: 'error',
            detail: `Invalid Token!`,
            summary: 'Error in verifying Token',
            life: 7000,
          })
        },
      )
  }
}
